import { Box, IconButton, Stack, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, useDisclosure } from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import { Link } from "react-router-dom";

const links = [
  { path: "/", text: "Home" },
  { path: "/topRated", text: "Top-Rated" },
  { path: "/clothing", text: "Clothing" },
  { path: "/dresses", text: "Dresses" },
  { path: "/wedding", text: "Wedding" },
  { path: "/shoes", text: "Shoes" },
  { path: "/accessories", text: "Accessories" },
  { path: "/gifts", text: "Gifts & Candless" },
  { path: "/beauty", text: "Beauty & Wellness" },
  { path: "/furniture", text: "Home Furniture" },
];

function NavbarCheck() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Box bg="gray.800" py={4} px={6} color="white">
      <Stack direction="row" align="center" justify="space-between">
        <Link to="/" fontWeight="bold" fontSize="lg">My Website</Link>
        <IconButton
          aria-label="Menu"
          variant="outline"
          colorScheme="white"
          size="md"
          icon={<HamburgerIcon />}
          onClick={onOpen}
        />
      </Stack>
      <Drawer placement="right" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerHeader borderBottomWidth="1px">Menu</DrawerHeader>
          <DrawerBody>
            <Stack spacing={4}>
              {links.map((link, index) => (
                <Link key={index} to={link.path}>{link.text}</Link>
              ))}
            </Stack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Box>
  );
}

export default NavbarCheck;